<div *ngFor="let additionalInfoItem of filteredAdditionalInfoItems; trackBy: trackByLabel">
  <div class="trigger"
       [ngClass]="additionalInfoItem.position">
    <img class="info-icon" *ngIf="additionalInfoItem.icon"
         [ngClass]="{'link': additionalInfoItem.location}"
         (click)="onTriggerClicked(additionalInfoItem.label)"
         src="{{additionalInfoItem.icon}}"/>
    <span *ngIf="additionalInfoItem.location"
          class="link"
          [ngClass]="{'visible-layer-link': visibleComponents.includes(additionalInfoItem.label)}"
          (click)="onTriggerClicked(additionalInfoItem.label)">
      {{additionalInfoItem.label}}
    </span>
    <span *ngIf="!additionalInfoItem.location">
      {{additionalInfoItem.label}}
    </span>
  </div>
  <div #loadedComponent></div>
</div>
<div style="display: none;"><div #componentsContainer></div></div>



// WEBPACK FOOTER //
// ./src/app/collage-designer/additional-info-items.component.html